import * as React from "react";

const Hero = () => (
  <section className="max-w-6xl mx-auto px-6 sm:px-10 pt-24 sm:pt-32 pb-20 sm:pb-28">
    <p className="text-xs uppercase tracking-[0.2em] text-stone-500 mb-8">
      Huskly
    </p>
    <h1 className="font-serif text-5xl sm:text-7xl lg:text-8xl leading-[1.05] tracking-tight text-stone-900 max-w-4xl">
      Finance research <span className="italic text-stone-600">&</span>{" "}
      development.
    </h1>
    <p className="mt-10 max-w-2xl text-lg sm:text-xl text-stone-600 leading-relaxed">
      We run Bitcoin treasury structures, build market data infrastructure, and
      open-source libraries — and we put our own capital behind it.
    </p>
  </section>
);

export default Hero;
